var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.00038 7.56724L7.18704 9.15835C7.53371 9.41613 8.00482 9.06946 7.87149 8.66057L7.03593 6.09168L9.19593 4.55391C9.55149 4.30502 9.37371 3.74502 8.93816 3.74502H6.28927L5.42704 1.06057C5.29371 0.651684 4.71593 0.651684 4.5826 1.06057L3.71149 3.74502H1.0626C0.627044 3.74502 0.449267 4.30502 0.804822 4.55391L2.96482 6.09168L2.12927 8.66057C1.99593 9.06946 2.46704 9.40724 2.81371 9.15835L5.00038 7.56724Z","fill":"#F5C13F"}));
}

Star.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = Star;

Star.default = Star;
